// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hiddenInput {
  opacity: 0;
  height: 0;
  padding: 0;
  border: none;
  position: absolute;
  z-index: 0;
  left: 45%;
}

:host h3 strong {
  color: var(--color-purple);
}

.primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}

.primary-button:link,
.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

.primary-button:hover, 
.primary-button:focus-visible {
  color: var(--color-white);
  border-color: transparent;
  background: var(--color-purple);
}
`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/participant-disqualify-demographic/participant-disqualify-demographic.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qCAAqC;EACrC,uGAAuG;AACzG;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC","sourcesContent":[".hiddenInput {\r\n  opacity: 0;\r\n  height: 0;\r\n  padding: 0;\r\n  border: none;\r\n  position: absolute;\r\n  z-index: 0;\r\n  left: 45%;\r\n}\r\n\r\n:host h3 strong {\r\n  color: var(--color-purple);\r\n}\r\n\r\n.primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n\r\n.primary-button:link,\r\n.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n.primary-button:hover, \r\n.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  border-color: transparent;\r\n  background: var(--color-purple);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
